import React from "react";
import { TextField } from "@mui/material";

export const InputText = (props) => {
  const { type, label, id, value, onChange, isRequired, isError, charLength } =
    props;
  return (
    <div>
      <label>
        {label}
        {isRequired && (
          <label
            style={{ color: "red", fontWeight: "bolder", fontSize: "18px" }}
          >
            *
          </label>
        )}
      </label>
      <TextField
        variant="outlined"
        size="small"
        fullWidth
        inputMode={type}
        id={id}
        value={value}
        onChange={onChange}
        required={isRequired}
        error={isError}
        inputProps={{ maxLength: charLength }}
        autoComplete="off"
      />
    </div>
  );
};
